import Route from '@ember/routing/route';

export default class FinanzenRoute extends Route {}
